











import {Vue, Component} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import Utils from '@/utils'

@Component({
  components: {
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Sheet: Utils.loadComponent('proxy/Sheet'),
    Button: Utils.loadComponent('Button'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
    CloseButton: Utils.loadComponent('CloseButton'),
  },
  name: 'BikeLockConfirm',
})
export default class BikeLockConfirm extends Vue {
  @Action('closeOverlays') protected closeOverlays: any

  protected bikeLocked() {
    this.closeOverlays()
  }
}
